import React from "react";
import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";
import img1 from "../../assets/homeAssets/tp1.webp";
import img2 from "../../assets/productsAsset/thp24.webp";
import img3 from "../../assets/productsAsset/thp1.webp";
import img4 from "../../assets/homeAssets/tp4.webp";
import img5 from "../../assets/productsAsset/thp26.webp";
import img6 from "../../assets/homeAssets/tp6.webp";
import { useTranslation } from "react-i18next";

const BestSellingThreePanel = () => {
  const { t } = useTranslation();
  return (
    <Container>
      <h1>{t("threePanels")}</h1>
      <Swiper
        className="swiper leftSwiper"
        pagination={true}
        modules={[Pagination, Autoplay]}
        slidesPerView={"auto"}
        spaceBetween={20}
        centeredSlides={true}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
      >
        <SwiperSlide className="slide">
          <Link to={"/prints/Purple%20World"}>
            <img src={img1} alt="" />
          </Link>
        </SwiperSlide>
        <SwiperSlide className="slide">
          <Link to={"/prints/Crystals"}>
            <img src={img2} alt="" />
          </Link>
        </SwiperSlide>
        <SwiperSlide className="slide">
          <Link to={"/prints/Three%20Gold%20Foil%20Flowers"}>
            <img src={img3} alt="" />
          </Link>
        </SwiperSlide>
        <SwiperSlide className="slide">
          <Link to={"/prints/Three%20Abstract%20Rainbow"}>
            <img src={img4} alt="" />
          </Link>
        </SwiperSlide>
        <SwiperSlide className="slide">
          <Link to={"/prints/Water%20in%20Gold"}>
            <img src={img5} alt="" />
          </Link>
        </SwiperSlide>
        <SwiperSlide className="slide">
          <Link to={"/prints/Womens%20Abstract%20Minimal"}>
            <img src={img6} alt="" />
          </Link>
        </SwiperSlide>
      </Swiper>
    </Container>
  );
};
const Container = styled.div`
  padding: 7em 7%;
  h1 {
    font-weight: 200;
    text-align: center;
    font-family: "Josefin Sans", sans-serif;
    font-size: 7em;
    text-transform: uppercase;
  }
  .swiper {
    display: flex;
    justify-content: center;
    align-items: center;
    .slide {
      width: 30%;
      max-width: 400px;
      img {
        width: 100%;
        cursor: pointer;
      }
    }
  }
  .swiper-pagination {
    width: 100%;
    position: absolute;
    bottom: 10px;
    display: flex;
    justify-content: center;
    left: 50%;
    transform: translateX(-50%);
  }
  .swiper-pagination-bullet {
    width: 24px;
    height: 7px;
    background-color: #ffffff; /* Change to your desired color */
    opacity: 0.7;
    margin: 0 5px;
    border-radius: 5px;
    cursor: pointer;
    box-shadow: 0 0 3px 1px gray;
    transition: background-color 0.3s ease;
  }
  .swiper-pagination-bullet-active {
    background-color: #444444; /* Change to your desired active color */
    opacity: 1;
  }
  @media (max-width: 650px) {
    .swiper {
      .slide {
        width: 700px;
      }
    }
  }
  @media (max-width: 500px) {
    h1 {
      font-size: 12vw;
    }
  }
`;

export default BestSellingThreePanel;
